/** Internal dependencies */
import { prepareApiCall } from './prepareApiCall';

export function handleFilter(e) {
    e.preventDefault();

    const parent = e.target.closest('[data-rest]');

    if (!parent) {
        return;
    }

    prepareApiCall(parent);
}
